import { createSlice } from "@reduxjs/toolkit";
import { enableMapSet } from "immer"; // 👈 Change this line
import { nextTab, prevTab } from "../components/kyc/kycSidebar";

enableMapSet();

const routeList = [
  {
    id: 1,
    code: "PD",
    route: "/kyc/person",
    icon: "pi-user",
    text: "Personal details",
    type: "I",
    order: 1,
  },
  {
    id: 2,
    code: "CD",
    route: "/kyc/company",
    icon: "pi-th-large",
    text: "Company details",
    type: "C",
    order: 2,
  },
  {
    id: 4,
    code: "AD",
    route: "/kyc/address",
    icon: "pi-map-marker",
    text: "Address details",
    order: 4,
  },
  {
    id: 5,
    code: "DD",
    route: "/kyc/director",
    icon: "pi-users",
    text: "Director details",
    type: "C",
    order: 5,
  },
  {
    id: 6,
    code: "FD",
    route: "/kyc/family",
    icon: "pi-users",
    text: "Family details",
    type: "I",
    order: 6,
  },
  {
    id: 7,
    code: "BKD",
    route: "/kyc/bank",
    icon: "pi-credit-card",
    text: "Bank details",
    order: 8,
  },
  {
    id: 8,
    code: "OD",
    route: "/kyc/occupation",
    icon: "pi-briefcase",
    text: "Occupation details",
    type: "I",
    order: 9,
  },
  {
    id: 9,
    code: "GD",
    route: "/kyc/guardian",
    icon: "pi-shield",
    text: "Guardian details",
    type: "I",
    order: 7,
  },
  {
    id: 10,
    code: "DOD",
    route: "/kyc/document",
    icon: "pi-file",
    text: "Document details",
    order: 3,
  },
  {
    id: 3,
    code: "BD",
    route: "/kyc/boid",
    icon: "pi-chart-bar",
    text: "BOID details",
    order: 10,
  },
  {
    id: 13,
    route: "/kyc/biometrics",
    icon: "pi-check-square",
    text: "Biometrics",
  },
  {
    id: 12,
    code: "DE",
    route: "/kyc/decleration",
    icon: "pi-check-square",
    text: "Declaration",
    order: 11,
  },
];

export const routerSlice = createSlice({
  name: "routerDetails",
  initialState: {
    completeSet: new Set(),
    sectionList: [],
    allSectionList: [],
  },
  reducers: {
    setGlobalList: (state, action) => {
      state.globalList = action.payload;
    },
    setSectionList: (state, action) => {
      state.allSectionList = action.payload
        .map((section) => {
          const rsection = routeList.find(
            (route) => route.code && route.code === section.code
          );

          return { ...(rsection || {}), ...section };
        })
        .sort((v1, v2) => v1.order - v2.order);

      state.sectionList = state.allSectionList.filter(
        (section) => !section.status || section.status === "E"
      );
    },
    setSectionComplete: (state, action) => {
      if (action.payload.isComplete) state.completeSet.add(action.payload.id);
      else state.completeSet.delete(action.payload.id);
    },
    setMainRouterData: (state, action) => {
      if (action.payload.formType) {
      }

      Object.keys(action.payload).forEach(
        (key) => (state[key] = action.payload[key])
      );
    },
    setScratchData: (state, action) => {
      state.scratchData = action.payload;
    },
    setDuplicateData: (state, action) => {
      state.duplicateData = action.payload;
    },
    disableSection: (state, action) => {
      const section = state.allSectionList.find(
        (section) => section.code === action.payload.code
      );
      if (section) {
        section.status = action.payload.flag ? "D" : "E";

        state.sectionList = state.allSectionList.filter(
          (section) => !section.status || section.status === "E"
        );
      }
    },
    setBlockForm: (state, action) => {
      state.blockForm = action.payload;
    },
    setActive: (state, action) => {
      const activeSectionId = action.payload;
      state.activeSectionId = activeSectionId;
    },
    setDcheck: (state, action) => {
      state.dChecked = action.payload;
    },
    setDname: (state, action) => {
      state.dName = action.payload;
    },
  },
});

export const {
  setGlobalList,
  setBlockForm,
  setDcheck,
  setDname,
  setSectionComplete,
  setActive,
  setSectionList,
  disableSection,
  setMainRouterData,
  setDeclarationStatus,
  setDeclarationName,
  setScratchData,
  setDuplicateData
} = routerSlice.actions;

export default routerSlice.reducer;
